import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Routes from '@/router'
import store, { history, persistor } from '@/store'
import { ConnectedRouter } from 'connected-react-router'
import { PersistGate } from 'redux-persist/integration/react'
import '@/i18n'
import '@/assets/style.less'
import '~antd/dist/antd.css';

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <Routes />
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)
